<template>
  <div>
    <div>
      <div class="head-cont">
        <span class="title">{{ name }}'s Circle</span>
        <div v-if="peopleCount + DoctorCount + HospitalCount + ClinicCount + HcpCount + NfpCount" class="sort-dropdown">
          <a-dropdown :trigger="['click']" :getPopupContainer="trigger => trigger.parentNode">
            <a class="show" @click="e => e.preventDefault()">
              Show <span class="all"> {{ selectedFilter }} </span> <a-icon type="down" />
            </a>
            <a-menu class="drop-ele" slot="overlay">
              <a-menu-item v-if="loading">
                <a> <a-spin size="small" class="mr-2" /> Loading... </a>
              </a-menu-item>
              <template v-else>
                <a-menu-item>
                  <a @click="() => handleSelectCircle('All')">All </a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="() => handleSelectCircle('People')">People ({{ peopleCount || 0 }}) </a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="() => handleSelectCircle('Hospitals')">Hospitals ({{ HospitalCount || 0 }}) </a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="() => handleSelectCircle('Clinics')">Clinics ({{ ClinicCount || 0 }})</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="() => handleSelectCircle('Non for profits')">Non for profits ({{ NfpCount || 0 }}) </a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="() => handleSelectCircle('Advanced Medical professionals')">Advanced Medical professionals ({{ HcpCount || 0 }}) </a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="() => handleSelectCircle('Physicans')">Physician ({{ DoctorCount || 0 }}) </a>
                </a-menu-item>
              </template>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
      <router-view :key="$route.path"></router-view>
    </div>

    <div :style="{ 'margin-top': '80px', 'margin-bottom': '20px' }">
      <OtherCircleMembers :name="name"></OtherCircleMembers>
    </div>
  </div>
</template>

<script>
import SelfCircleMembers from "./SelfCircleMembers"
import SelfCircleMembersAll from "./viewSelfCircleMembersAll.vue"
import OtherCircleMembers from "./OtherCircleMembers"
import SelfProviders from "./SelfProviders"
import { RepositoryFactory } from "../../../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "ProfileCircleLayout",
  components: {
    SelfCircleMembers,
    OtherCircleMembers,
    SelfProviders,
    SelfCircleMembersAll,
  },

  data() {
    return {
      currentPage: 1,
      limit: 20,
      active: "people",
      selectedFilter: "All",
      mobileSelectedCircle: "",
      name: "",
      peopleCount: 0,
      DoctorCount: 0,
      HospitalCount: 0,
      ClinicCount: 0,
      HcpCount: 0,
      NfpCount: 0,
      loading: false,
    }
  },

  created() {
    console.warn("view/Circle.vue is created")
    this.init()
    this.name =
      this.viewUser.role === "hospital"
        ? this.viewUser.hospital_info.hospital_name
        : this.viewUser.role === "clinic"
        ? this.viewUser.clinic_info.clinic_name
        : this.viewUser.role === "nfp"
        ? this.viewUser.nfp_info.nfp_name
        : this.viewUser.display_name
        ? this.viewUser.display_name
        : this.viewUser.doctor_info.full_name
    // this.name = this.name.replace(/\b(\w)/g, s => s.toUpperCase())

    const type = this.$route.fullPath.split("/")

    if (type[type.length - 1] === "other") {
      this.isShowFilter = false
      this.mobileSelectedCircle = `Circle ${this.name}  is part of`
    } else {
      this.isShowFilter = true
      this.mobileSelectedCircle = ` ${this.name}  's circle`
    }
  },

  watch: {
    "$route.fullPath": function(newVal, old) {
      const type = this.$route.fullPath.split("/")
      if (type[type.length - 1] === "other") {
        this.isShowFilter = false
      } else {
        this.isShowFilter = true
      }
    },
  },

  mounted() {},

  methods: {
    async init() {
      try {
        this.loading = true
        UserRepository.getCircleMembersCount(this.viewUser, this.currentCircle.id, 1, 1).then(res => {
          this.peopleCount = parseInt(res.data.people_count)
          this.DoctorCount = parseInt(res.data.doctor_count)
          this.HospitalCount = parseInt(res.data.hospital_count)
          this.ClinicCount = parseInt(res.data.clinic_count)
          this.HcpCount = parseInt(res.data.hcp_count)
          this.NfpCount = parseInt(res.data.nfp_count)
        })
        // const res1 = await UserRepository.getSelfCircleMembers(this.viewUser, this.currentCircle.id, this.currentPage, this.limit)
        // if (res1.data.message === "found") {
        //   this.peopleCount = parseInt(res1.data.data.paginator.total_count)
        // } else {
        //   this.peopleCount = 0
        // }
        // const res2 = await UserRepository.getCircleProviders(this.viewUser, this.currentCircle.id, this.currentPage, this.limit)
        // this.DoctorCount = parseInt(res2.data.data.doctors.doctors_paginator.total_count)
        // this.HospitalCount = parseInt(res2.data.data.hospitals.hospitals_paginator.total_count)
        // this.ClinicCount = parseInt(res2.data.data.clinics.clinics_paginator.total_count)
        // this.HcpCount = parseInt(res2.data.data.hcps.hcps_paginator.total_count)
        // this.NfpCount = parseInt(res2.data.data.nfps.nfps_paginator.total_count)
        this.loading = false
      } catch (e) {
        console.log(e)
        // this.$notification.error({ message: "Error", description: "Count could not be fetched" })
        this.loading = false
      }
    },

    handleSelectCircle(type) {
      this.selectedFilter = type
      if (type === "Others") {
        this.mobileSelectedCircle = `Circle ${this.name}  is part of`
      } else {
        this.mobileSelectedCircle = this.name + "'s Circle"
      }
      switch (type) {
        case "All":
          this.$router.push({ path: `ViewAllCircle` })
          break
        case "People":
          this.$router.push({ path: `self` })
          break
        case "Hospitals":
          this.$router.push({ path: `hospitals` })
          break
        case "Clinics":
          this.$router.push({ path: `clinics` })
          break
        case "Non for profits":
          this.$router.push({ path: `nfp` })
          break
        case "Advanced Medical professionals":
          this.$router.push({ path: `hcp` })
          break
        case "Physicans":
          this.$router.push({ path: `providers` })
          break
        case "Others":
          this.$router.push({ path: `other` })
          break
        default:
          console.log("none")
          break
      }

      //   $router.push({
      //             path: `allCircleMembers`
      //           });
      //           active = 'people';

      //  $router.push({ path: `self` });
      //           active = 'people';

      // $router.push({
      //             path: `hospitals`,
      //             params: { type: 'hospitals' }
      //           });
      //           $router.push({
      //             path: `clinics`,
      //             params: { type: 'clinics' }
      //           });
      //           $router.push({
      //             path: `nfp`,
      //             params: { type: 'nfp' }
      //           });
      //           $router.push({
      //             path: `hcp`,
      //             params: { type: 'hcp' }
      //           });
      //           $router.push({
      //             path: `providers`,
      //             params: { type: 'providers' }
      //           });
    },
  },
}
</script>

<style lang="scss" scoped>
/* .nav {
  flex-wrap: nowrap !important;
}
.nav-item {
  width: 32%;
}
.circle-nav > .nav-item > .nav-link {
  border: 1px solid #1674bf;
  font-weight: bold;
  border-radius: 0;
}
.circle-nav > .nav-item:first-child > .nav-link {
  border-radius: 20px 0 0 20px;
}
.circle-nav > .nav-item:last-child > .nav-link {
  border-radius: 0 20px 20px 0;
} */

.show {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734 !important;
  white-space: nowrap;
}

.all {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734 !important;
}

.head-cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  @media screen and (max-width: 700px) {
    flex-wrap: wrap;
    gap: 10px;
  }
}

.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  display: flex;
}

.mobile {
  display: none;

  @media screen and (max-width: 900px) {
    display: flex;
  }
}

.circle-nav {
  @media screen and (max-width: 900px) {
    display: none !important;
  }
}

.circle-select-dropdown {
  display: flex;
  justify-content: flex-end;
  margin: 16px 30px;

  @media screen and (max-width: 900px) {
    justify-content: space-between;
    margin: 20px 12px;
    margin-left: 0px;
  }
}

.circle-selected {
  background: red;
}

ul li.selected {
  background: yellow;
}

.circle-members-mobile {
  display: none;

  @media screen and (max-width: 900px) {
    display: inline-flex;
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/profile/circle/view/Circle.vue